var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.38 17.62c-1.422-1.424-3.828-1.37-5.369.173l-3.81 3.81c-1.543 1.542-1.597 3.947-.174 5.37s3.828 1.37 5.37-.173l1.906-1.905a.735.735 0 1 0-1.04-1.04l-1.906 1.906c-.946.946-2.417 1.046-3.29.172-.874-.873-.774-2.344.172-3.29l3.81-3.81c.947-.947 2.42-1.047 3.292-.174a.735.735 0 1 0 1.04-1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.57 21.43a3.675 3.675 0 0 0 5.196 0l4.158-4.157a3.678 3.678 0 0 0 0-5.197 3.675 3.675 0 0 0-5.197 0l-2.079 2.08a.735.735 0 0 0 1.04 1.039l2.078-2.08a2.204 2.204 0 1 1 3.118 3.119l-4.157 4.157a2.207 2.207 0 0 1-3.118 0 .734.734 0 1 0-1.039 1.039z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.5e4bba9d25431740cc7e4e0e5cbef04f.svg";
export { ForwardRef as ReactComponent };